// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1x0M6","title":"Info_title__18tlM","selects":"Info_selects__3w9X7","requiredAsterisk":"Info_requiredAsterisk__3oaiL"};